module.exports = __webpack_public_path__ + "static/media/front-desk-pro-tip-multiple-appts.28a37d41.png";